import { useEffect, useMemo, useState } from 'react';

import {
  CLASSROOM_LIST_TABS,
  ClassroomListTab,
} from '@/pages/classrooms/components/ClassroomListTabs';

// showOwnedTab: 학생 계정은 과거에 만든 클래스가 있어도 학생으로만 다뤄 '만든 클래스' 탭을 숨긴다.
export function useDashboardTabState(
  showOwnedTab: boolean,
  defaultToOwnedTab: boolean,
) {
  const defaultActiveTab = defaultToOwnedTab
    ? ClassroomListTab.OWNED_CLASSROOMS
    : ClassroomListTab.JOINED_CLASSROOMS;
  const [activeTab, setActiveTab] =
    useState<ClassroomListTab>(defaultActiveTab);
  const [hasSelectedTab, setHasSelectedTab] = useState(false);
  const tabs = useMemo(
    () =>
      showOwnedTab
        ? CLASSROOM_LIST_TABS
        : CLASSROOM_LIST_TABS.filter(
            tab => tab.value === ClassroomListTab.JOINED_CLASSROOMS,
          ),
    [showOwnedTab],
  );

  useEffect(() => {
    if (hasSelectedTab) return;
    setActiveTab(defaultActiveTab);
  }, [defaultActiveTab, hasSelectedTab]);

  const handleChangeTab = (tab: ClassroomListTab) => {
    setHasSelectedTab(true);
    setActiveTab(tab);
  };

  return { activeTab, tabs, handleChangeTab };
}
